<template>
  <div class="owc-table wb-grid-container">
    <ValidationBoxWrapper v-if="isEditMode">
      <slot slot="validation-box" name="validation-box" />
    </ValidationBoxWrapper>
    <SlotContainer
      refName="slot-tableDetail"
      class="wb-grid-row owc-table__details"
      :slot-component-data="JSON.stringify({ parentAccordionId: currentAccordionId })"
    >
      <slot></slot>
    </SlotContainer>
  </div>
</template>

<script lang="ts">
/**
 * Table Component
 * The Table module is going to be use on the PI pages.
 * It will render table detail modules inside.
 *
 * Inside the table module, the author need to configure at least one table detail module, including at least one table cell module.
 *
 * The author can decide, whether the (multiple) table detail components should be shown as an accordion:
 *  - show as accordion (boolean)
 */
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';
import SlotContainer from '@owc-packages/SlotContainer/src/SlotContainer.vue';

export default ComponentInitializeDispatcher.extend({
  name: 'owc-table',
  components: {
    SlotContainer,
    ValidationBoxWrapper,
  },
  computed: {
    currentAccordionId: function() {
      return this.componentId;
    },
  },
});
</script>

<style lang="scss">
.owc-table {
  @include wb-content-width;

  background-color: var(--wb-white);

  &__details {
    margin-bottom: var(--wb-spacing-xs);
  }
}
</style>
